import { isUndefined } from 'lodash';
import axios, {
  getRequest,
  patchRequest,
  postRequest,
  updateRequest,
} from 'src/utils/axios';
import logger from 'src/utils/logger';
import parse from 'src/utils/parse';
import { GetListsApiProps } from './companiesApi';

class ContactsApi {
  async getAll(
    page: number,
    limit: number,
    isActivated: string | boolean,
    search: any,
    columns?: any,
    sort?: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const payload = {
        page,
        pageSize: limit,
        isActive: isActivated,
        search,
        column: columns,
        sort: sort === 'asc' ? '1' : '-1',
      };

      if (isActivated === 'all') {
        delete payload.isActive;
      }
      if (columns === undefined || columns === '') {
        delete payload.column;
        delete payload.sort;
      }
      if (search === '') {
        delete payload.search;
      }
      if (sort === '') {
        delete payload.sort;
      }
      axios
        .get(`${process.env.REACT_APP_CASES}/user`, { params: payload })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async createCompanyContact(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        reject(error);
      };
      const data = {
        url: `${process.env.REACT_APP_CASES}/contact`,
        payload,
        successFunction,
        errorFunction,
      };
      postRequest(data);
    });
  }

  async updateCompanyContactById(id: string, payload: any): Promise<any> {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_CASES}/contact/${id}`,
        payload
      );

      return response;
    } catch (error) {
      logger(error, 'error');
      throw error;
    }
  }

  async getAllContactsByOrganizationId(params: GetListsApiProps): Promise<any> {
    return new Promise((resolve, reject) => {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, String(value));
        }
      });

      axios
        .get(`${process.env.REACT_APP_CASES}/contact?${queryParams.toString()}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch(() => {
          reject(new Error('internal Server Error'));
        });
    });
  }

  async bulkDeactivate(checkedIds: Array<number>): Promise<any> {
    return new Promise((resolve, reject) => {
      const payload: any = {
        list: checkedIds,
      };
      axios
        .patch(
          `${process.env.REACT_APP_EXTERNAL_USER_URL}/users/bulk-deactivate?isExternal=true`,
          payload
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  async create(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        reject(error);
      };
      const data = {
        url: `${process.env.REACT_APP_CASES}/user`,
        payload,
        successFunction,
        errorFunction,
      };
      postRequest(data);
    });
  }

  async getById(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        reject(error);
      };
      const data = {
        url: `${process.env.REACT_APP_CASES}/user/${id}`,
        successFunction,
        errorFunction,
      };
      getRequest(data);
    });
  }

  async updateById(id: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        reject(error);
      };
      const data = {
        url: `${process.env.REACT_APP_CASES}/user/${id}`,
        payload,
        successFunction,
        errorFunction,
      };
      updateRequest(data);
    });
  }

  async updateByIdWithPassword(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        reject(error);
      };
      const data = {
        url: `${process.env.REACT_APP_CASES}/user/update`,
        payload,
        successFunction,
        errorFunction,
      };
      patchRequest(data);
    });
  }

  async updateStatusById(id: number, status: boolean) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${process.env.REACT_APP_CASES}/user/${id}/${status}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }


  /** Toggle contact active/inactive status */
  async toggleContactStatus(id: string, status: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${process.env.REACT_APP_CASES}/contact/${id}/${status}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  /** Reset/change user password by email */
  async resetPassword(email: string, password: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${process.env.REACT_APP_CASES}/user/password/change/${encodeURIComponent(email)}`,
          { password }
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  /** Reset QR code for user by email */
  async resetQrCode(email: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_CASES}/user/auth/qr-code/${encodeURIComponent(email)}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }
}

export const contactsApi = new ContactsApi();
